module.exports = __webpack_public_path__ + "static/media/student-score-next.ff144590.png";